export const en = {
  "commentary-bar.pre-start": "Race is about to begin!",
  "commentary-bar.race-start": "And we're off!",
  "control-panel.cycle-horses": "Cycle Cameras",
  "countdown-clock.event-starts": "Race starts in: ",
  "markets-panel.header.form": "Form",
  "markets-panel.header.winner": "Winner",
  "markets-panel.loading": "Loading competitors...",
  "markets-panel.label": "Virtually Sports Horse Racing",
  "swipe-screen": "HORSE RACING",
};
